import * as React from "react";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { Form, Input, Button } from "antd";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { Spin } from "Components/General/Spin";
import { useForm } from "antd/lib/form/Form";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";
import { useParams } from "react-router-dom";

export const AutoMapping = () => {
  const params = useParams();
  const { t } = useTranslation(I18N_NS.ADMIN);
  const [loading, setLoading] = React.useState(false);
  const [form] = useForm();

  const fetch = async () => {
    try {
      setLoading(true);
      const response = await API.request(API_URL.ADMIN_PROJECTS.getDirectoryMapping(params.id), {
        method: "GET",
        responseType: "text",
      });
      form.setFields([{ name: "definition", value: response }]);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const handleFinish = async ({ definition }) => {
    try {
      setLoading(true);
      await API.editData(API_URL.ADMIN_PROJECTS.saveDirectoryMapping(params.id), definition);
      notificationSuccess(t("Success"), t("Definition was saved"));
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetch();
  }, []);

  return (
    <div className="g-card">
      <h1>{t("Mapping for the automatic assignment of files to the target directory for Project")}</h1>
      <Spin spinning={loading}>
        <Form layout="vertical" form={form} onFinish={handleFinish}>
          <Form.Item label={t("Directory mapping definition (in XML)")} name="definition">
            <Input.TextArea autoSize={{ minRows: 5 }} />
          </Form.Item>
          <div className="text-right">
            <Button type="primary" htmlType="submit">
              {t("Save")}
            </Button>
          </div>
        </Form>
      </Spin>
    </div>
  );
};
